import { AxiosService } from '../../../utils/AxiosService';
import Config from '../../../config';

const getBiometricMatrixProgress = async userId => await AxiosService.get(Config.server.api.biometricMatrixApi + `admin/user/${userId}`, {}, true);

export default {
    getBiometricMatrixProgress
}